


















































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import clientRegisterService from '@/services/ClientRegisterService';

import {
  AnswerRequest,
  AnswerResponse,
  APIResponse,
  ClientStatus,
  QuestionResponse,
  QuestionTO,
  RegisterRequest,
  RegisterResponse,
  TokenRequest,
  TokenResponse,
} from '@/models';
import VueRecaptcha from 'vue-recaptcha';
import ApiError from '@/models/ApiError';
import ValidationHelper from '@/helpers/ValidationHelper';

declare const document: any;

@Component({
  components: {
    VueRecaptcha,
  },
})
export default class RegisterMeuFinanciamentoArisco extends Vue {
  public token: string = '';
  public question: QuestionTO | null = null;
  public tokenResponse: TokenResponse | null = null;

  public finishedRegister: boolean = false;
  public hasQuestion: boolean = false;
  public hasAnswer: boolean = false;
  public questionResponse: QuestionResponse | null = null;

  public mothersFirstName: string | null = null;
  public birthdayDay: string = '';
  public birthdayYear: string = '';
  public answerResponse: AnswerResponse | null = null;

  public email: string = '';
  public confirmEmail: string = '';
  public password: string = '';
  public confirmPassword: string = '';
  public registerResponse: RegisterResponse | null = null;
  public name: string = '';
  public nickname: string = '';

  public isBusy: boolean = false;
  public touchedFields = new Set();
  public recaptchaReady: boolean = false;

  public loginEmAndamento: boolean = false;

  public markAsTouched(field: string) {
    this.touchedFields.add(field);
  }

  /// NOVOS METODOS ///
  public recaptchaSiteKey: string = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
  public cpf: string = '';

  public localErrors: ApiError[] = [];

  public reset() {
    this.cpf = '';
  }

  public validarCpf(cpf: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== 'cpf');
    const erro = {property: 'cpf', message: ''};

    if (!cpf) {
      erro.message = 'Informe um CPF.';
      this.localErrors.push(erro);
      return;
    }

    const v = ValidationHelper.cpf(cpf);
    if (!v) {
      erro.message = 'O CPF informado é inválido.';
      this.localErrors.push(erro);
    }
  }

  public validarBirthdayDay(day: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== 'birthdayDay');

    if (!day || day.trim() === '') {
      this.localErrors.push({property: 'birthdayDay', message: 'Informe o dia de nascimento.'});
      return;
    }

    const dayNum = parseInt(day, 10);
    if (isNaN(dayNum) || dayNum <= 0 || dayNum > 31) {
      this.localErrors.push({property: 'birthdayDay', message: 'Informe um dia de nascimento válido.'});
    }
  }

  public validarBirthdayYear(year: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== 'birthdayYear');

    if (!year || year.trim() === '') {
      this.localErrors.push({property: 'birthdayYear', message: 'Informe o ano de nascimento.'});
      return;
    }

    const yearNum = parseInt(year, 10);
    if (isNaN(yearNum) || yearNum <= 1900 || yearNum > (new Date()).getFullYear() - 17) {
      this.localErrors.push({property: 'birthdayYear', message: 'Informe um ano de nascimento válido.'});
    }
  }

  public validarEmail(email: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== 'email');

    if (!email || email.trim() === '') {
      this.localErrors.push({property: 'email', message: 'Informe o endereço de e-mail.'});
      return;
    }

    const isValidEmail = ValidationHelper.email(email);
    if (!isValidEmail) {
      this.localErrors.push({property: 'email', message: 'Endereço de e-mail inválido.'});
    }
  }

  public validarConfirmEmail(confirmEmail: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== 'confirmEmail');

    if (!confirmEmail || confirmEmail.trim() === '') {
      this.localErrors.push({property: 'confirmEmail', message: 'Confirme seu endereço de e-mail.'});
      return;
    }

    if (this.email !== confirmEmail) {
      this.localErrors.push({property: 'confirmEmail', message: 'Os e-mails devem ser iguais.'});
    }
  }

  public validarPassword(password: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== 'password');

    if (!password || password.trim() === '') {
      this.localErrors.push({property: 'password', message: 'Informe a senha de acesso.'});
      return;
    }

    if (password.length < 8) {
      this.localErrors.push({property: 'password', message: 'A senha deve ter no mínimo 8 caracteres.'});
      return;
    }

    if (password.length > 14) {
      this.localErrors.push({property: 'password', message: 'A senha deve ter no máximo 14 caracteres.'});
      return;
    }

    const numeros = /([0-9])/;
    const alfabeto = /([a-zA-Z])/;
    const chEspeciais = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;

    if (!password.match(numeros) || !password.match(alfabeto) || !password.match(chEspeciais)) {
      this.localErrors.push({property: 'password', message: 'Senha deve conter letra, número e caracter especial.'});
    }
  }

  public validarConfirmPassword(confirmPassword: string) {
    this.localErrors = this.localErrors.filter((e) => e.property !== 'confirmPassword');

    if (!confirmPassword || confirmPassword.trim() === '') {
      this.localErrors.push({property: 'confirmPassword', message: 'Confirme sua senha de acesso.'});
      return;
    }

    if (this.password !== confirmPassword) {
      this.localErrors.push({property: 'confirmPassword', message: 'As senhas devem ser iguais.'});
    }
  }
  
  public dialogModal(): any {
    // @ts-ignore
    return this.$dialogModal;
  }
  
  public window(): any {
    // @ts-ignore
    return window;
  }

  public solicitarLogin() {
    console.log('solicitarLogin');
    this.isBusy = true;

    // Verifica se o recaptcha está carregado antes de usar
    if (!this.recaptchaReady) {
      console.warn('Recaptcha não foi carregado ainda. Tentando novamente em 500ms...');
      this.isBusy = false;
      setTimeout(() => this.solicitarLogin(), 500);
      return;
    }
    this.markAsTouched('cpf');
    this.validarCpf(this.cpf);

    if (this.localErrors.length) {
      this.isBusy = false;
      this.dialogModal().show(
          'Verifique seus dados',
          this.localErrors[0].message!,
          [{text: 'Vamos lá'}],
          false
      );
      return;
    }
    const recaptchaRef = this.$refs.recaptcha as VueRecaptcha;
    console.log('solicitarLogin - chamando recaptcha');
    recaptchaRef.reset();
    console.log('test 1')
    recaptchaRef.execute();
    console.log('test 2')
  }

  public possuiErros(field: string): boolean {
    let result = this.touchedFields.has(field) && !!this.localErrors.find((erro) => erro.property === field);
    return result;
  };

  public mensagemErro(field: string): string {
    const errors = this.localErrors.filter((erro) => erro.property === field);
    return errors.length ? errors[0].message || '' : '';
  };
  
  public recaptchaRenderizado() {
    this.recaptchaReady = true;
  }

  public recaptchaValidado(tokenRecaptcha: string) {
    this.loadQuestion(tokenRecaptcha);
  }

  public showErrorMessage(message = '', error: any) {
    if (error.response && error.response.data && error.response.data.omniSpanId) {
      message += `\n\n OmniSpanId: ${error.response.data.omniSpanId}`;
    }

    this.dialogModal().show(
        'Erro',
        message,
        [{text: 'OK'}],
        false
    );
  }


  // FIM NOVOS METODOS ///

  public async loadQuestion(recaptcha: string) {
    (this.$refs.recaptcha as VueRecaptcha).reset();
    this.isBusy = true;

    const tokenRequest = {
      document: this.cpf,
      recaptchaResponse: recaptcha,
      clientId: localStorage.getItem('omni-keycloak-clientId'),
    } as TokenRequest;

    try {
      this.tokenResponse = await clientRegisterService.token(tokenRequest);
      if (
          this.tokenResponse.status === APIResponse.INCORRECT_CAPTCHA_RESPONSE
      ) {
        this.isBusy = false;
        this.dialogModal().show(
            'Erro',
            'Erro no CAPTCHA. Tente novamente.',
            [{text: 'OK'}],
            false
        );
        return;
      } else if (this.tokenResponse.status === APIResponse.CLIENT_NOT_FOUND) {
        this.isBusy = false;
        this.dialogModal().show(
            'Erro',
            'Cliente não encontrado.',
            [{text: 'OK'}],
            false
        );
        return;
      } else if (
          this.tokenResponse.status === APIResponse.INSUFFICIENT_CLIENT_DATA
      ) {
        this.isBusy = false;
        this.dialogModal().show(
            'Erro',
            'Cliente não encontrado ou dados insuficientes.',
            [{text: 'OK'}],
            false
        );
        return;
      } else if (
          this.tokenResponse.status === APIResponse.INVALID_CLIENT_STATUS
      ) {
        this.isBusy = false;
        this.dialogModal().show(
            'Erro',
            this.getInvalidStatusErrorMessage(this.tokenResponse),
            [{text: 'OK'}],
            false
        );
        return;
      }
      this.token = this.tokenResponse.token;
      this.questionResponse = await clientRegisterService.question(this.token);
      this.question = this.questionResponse.question;
      this.hasQuestion = this.questionResponse.status === APIResponse.SUCCESS;
    } catch (error) {
      let errorMsg = 'Ocorreu um erro. Tente novamente mais tarde.';
      if (error.response && error.response.data.status === APIResponse.USER_ALREADY_EXISTS) {
        errorMsg = 'Esse CPF já possui cadastro no Portal, digite a senha cadastrada ou clique em esqueci minha senha.';
      }
      this.showErrorMessage(errorMsg, error);
      this.isBusy = false;
    } finally {
      this.isBusy = false;
    }
  }

  public async sendAnswer(e: Event) {
    this.isBusy = true;

    // Validar e marcar como touched
    this.markAsTouched('birthdayDay');
    this.markAsTouched('birthdayYear');
    this.markAsTouched('mothersFirstName');

    this.validarBirthdayDay(this.birthdayDay);
    this.validarBirthdayYear(this.birthdayYear);

    let errosFiltrados = this.localErrors
        .filter((e) => ['birthdayDay', 'birthdayYear', 'mothersFirstName'].indexOf(e.property!) !== -1);

    if (!this.mothersFirstName) {
      errosFiltrados.push({property: 'mothersFirstName', message: 'Informe o nome da mãe.'});
    }

    if (errosFiltrados.length > 0) {
      this.isBusy = false;

      this.dialogModal().show(
          'Verifique seus dados',
          errosFiltrados[0].message!,
          [{text: 'Vamos lá'}],
          false
      );
      return;
    }

    const answerRequest = {
      birthdayDay: parseInt(this.birthdayDay, 10),
      birthdayYear: parseInt(this.birthdayYear, 10),
      mothersFirstName: this.mothersFirstName,
    } as AnswerRequest;

    try {
      this.answerResponse = await clientRegisterService.answer(
          answerRequest,
          this.token);
      if (this.answerResponse.status === APIResponse.INCORRECT_ANSWER) {
        this.isBusy = false;
        this.dialogModal().show(
            'Verifique seus dados',
            'Dados incorretos.',
            [{text: 'Vamos lá'}],
            false
        );
        return;
      } else if (this.answerResponse.status === APIResponse.TOKEN_ERROR) {
        this.isBusy = false;
        this.dialogModal().show(
            'Erro',
            'Acesso bloqueado por divergência na validação dos dados cadastrais. Por gentileza entre em contato com nossa Central de Relacionamento: 4004-7232 (Capitais e Regiões Metropolitanas) 0800 888 3588 (Demais Regiões). Atendimento de segunda-feira a sábado das 8h às 20h. SAC: 0800 000 5691 - Atendimento para todos os produtos, 24 horas, 7 dias por semana',
            [{text: 'Vamos lá'}],
            false
        );
        return;
      }
      this.hasAnswer = this.answerResponse.status === APIResponse.SUCCESS;
    } catch (error) {
      let errorMsg = 'Ocorreu um erro. Tente novamente mais tarde.';
      if (error.response && error.response.data.status === APIResponse.USER_ALREADY_EXISTS) {
        errorMsg = 'Esse CPF já possui cadastro no Portal, digite a senha cadastrada ou clique em esqueci minha senha.';
      }
      this.showErrorMessage(errorMsg, error);
      this.isBusy = false;
    } finally {
      this.isBusy = false;
    }
  }

  public async sendRegister(e: Event) {
    this.isBusy = true;

    // Marcar todos os campos como touched
    this.markAsTouched('email');
    this.markAsTouched('confirmEmail');
    this.markAsTouched('password');
    this.markAsTouched('confirmPassword');

    // Validar todos os campos
    this.validarEmail(this.email);
    this.validarConfirmEmail(this.confirmEmail);
    this.validarPassword(this.password);
    this.validarConfirmPassword(this.confirmPassword);

    // Se houver erros, mostrar e retornar
    if (this.localErrors.length > 0) {
      this.isBusy = false;
      this.dialogModal().show(
          'Verifique seus dados',
          this.localErrors[0].message!,
          [{text: 'Vamos lá'}],
          false
      );
      return;
    }

    try {
      const registerRequest = {
        acceptNotifications: true,
        acceptTermsAndConditions: true,
        email: this.email,
        password: this.password,
        nickname: this.nickname,
        redirectUri: localStorage.getItem('omni-keycloak-redirectUri'),
        clientId: localStorage.getItem('omni-keycloak-clientId'),
      } as RegisterRequest;

      this.registerResponse = await clientRegisterService.register(registerRequest, this.token);

      if (this.registerResponse.status === APIResponse.EMAIL_ALREADY_IN_USE) {
        this.isBusy = false;
        this.dialogModal().show(
            'Verifique seus dados',
            'Não foi possível registrar o usuário pois o e-mail já está em uso.',
            [{text: 'Vamos lá'}],
            false
        );
        return;
      }

      this.finishedRegister = this.registerResponse.status === APIResponse.SUCCESS;

    } catch (error) {
      let errorMsg = 'Não foi possível realizar o cadastro.';
      if (error.response.data.status === APIResponse.USER_ALREADY_EXISTS) {
        errorMsg = 'Esse CPF já possui cadastro no Portal, digite a senha cadastrada ou clique em esqueci minha senha.';
      }
      this.showErrorMessage(errorMsg, error);
      this.isBusy = false;
    } finally {
      this.isBusy = false;
    }
  }

  public getInvalidStatusErrorMessage(response: any): string {
    let errorMessage = '';
    const [responseMessage]: string[] = response.messages;

    const [_, status] = responseMessage.split(': ');

    switch (status) {
      case ClientStatus.REGISTERED:
        errorMessage = 'CPF já cadastrado no sistema.';
        break;

      case ClientStatus.BLOCKED:
        errorMessage =
            'Acesso bloqueado por divergência  na validação dos dados cadastrais. Por gentileza entre em contato com nossa Central de Relacionamento 08007013500 ou 4004-3500.';
        break;

      default:
        break;
    }

    return errorMessage;
  }

  @Watch('email')
  public watchEmail(data: string) {
    this.email = data.trim().toLowerCase();
  }

  @Watch('confirmEmail')
  public watchConfirmEmail(data: string) {
    this.confirmEmail = data.trim().toLowerCase();
  }

  @Watch('hasQuestion')
  public watchHasQuestion(newVal: number, oldVal: number) {
    if (newVal && !oldVal) {
      this.isBusy = false;
    }
  }

  @Watch('hasAnswer')
  public watchHasAnswer(newVal: number, oldVal: number) {
    if (newVal && !oldVal) {
      this.isBusy = false;
    }
  }

  public maxLength(event: Event, model: string, maxLength: number) {
    const element: HTMLInputElement | null = event.target as HTMLInputElement;
    const value = element.value;

    if (String(value).length > maxLength) {
      const newValue = String(value).substring(0, maxLength);
      Reflect.set(this, model, newValue);
    }
  }

  mounted() {
    let queryParamCpf = this.$route.query.cpf;
    if (queryParamCpf) {
      this.cpf = queryParamCpf.toString();
      this.solicitarLogin();
    }
  }
}
